import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
  Switch,
  alpha
} from '@mui/material';

interface PrivacyTabProps {
  colors: any;
  glassStyle: any;
}

const PrivacyTab: React.FC<PrivacyTabProps> = ({ colors, glassStyle }) => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Data & Privacy
      </Typography>
      <Typography color={colors.textSecondary} sx={{ mb: 4 }}>
        Controls for how your data is used.
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: colors.cardBg, borderRadius: '24px', p: 4, border: `1px solid ${alpha(colors.textSecondary, 0.1)}` }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2 }}>
          <Box>
            <Typography color={colors.textPrimary} fontWeight={600}>
              Use data to improve my experience
            </Typography>
            <Typography variant="body2" color={colors.textSecondary}>
              Allows us to use your usage data to improve Discord.
            </Typography>
          </Box>
          <Switch defaultChecked color="success" />
        </Box>
        <Divider sx={{ opacity: 0.1 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2 }}>
          <Box>
            <Typography color={colors.textPrimary} fontWeight={600}>
              Allow use of my data for analytics
            </Typography>
            <Typography variant="body2" color={colors.textSecondary}>
              Helps us understand how people use our services.
            </Typography>
          </Box>
          <Switch color="success" />
        </Box>
        <Divider sx={{ opacity: 0.1 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2 }}>
          <Box>
            <Typography color={colors.textPrimary} fontWeight={600}>
              DM Spam Filter
            </Typography>
            <Typography variant="body2" color={colors.textSecondary}>
              Automatically scan DMs for spam.
            </Typography>
          </Box>
          <Switch defaultChecked color="success" />
        </Box>
      </Paper>
    </Box>
  );
};

export default PrivacyTab;